module.exports = __webpack_public_path__ + "assets/img/tx102st.90db770a.jpg";